var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.loginStatus && _vm.bindEthereum ? _c('div', {
    staticClass: "nft_wallet_wrap"
  }, [_c('div', {
    staticClass: "header_tool_btn"
  }, [_c('a', {
    attrs: {
      "href": "/app/nft/dist/index.html"
    }
  }, [_vm._v(_vm._s(_vm.$t('nftWallet')))])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };